export const MONTHS = [
    { id: 0, title: 'Январь' },
    { id: 1, title: 'Февраль' },
    { id: 2, title: 'Март' },
    { id: 3, title: 'Апрель' },
    { id: 4, title: 'Май' },
    { id: 5, title: 'Июнь' },
    { id: 6, title: 'Июль' },
    { id: 7, title: 'Август' },
    { id: 8, title: 'Сентябрь' },
    { id: 9, title: 'Октябрь' },
    { id: 10, title: 'Ноябрь' },
    { id: 11, title: 'Декабрь' },
];

const setYearsList = () => {
    const currentYear = new Date().getFullYear();
    const firstYear = 1960;

    const years = [];
    let index = 0;

    for (let i = currentYear; i >= firstYear; i -= 1) {
        const year = { id: index, title: currentYear - index };
        years.push(year);
        index += 1;
    }

    return years;
};

export const YEARS = setYearsList();

export const DEFAULT_TREE_ITEM = 'baseRateChangeFactor';

export const DEFAULT_DEV_OBJ_PANEL_SETTINGS = {
    code: 'actualOilProductionRates',
    gtmCodeId: null,
};

export const DEFAULT_CHART_SETTINGS = {
    // дебиты жидкости
    liquidProductionRateFactM3: { type: 'line', color: '#2163FF', commonCode: 'liquidProductionRate', isActive: true },
    liquidProductionRateTheorFallM3: {
        type: 'point',
        color: '#2163FF',
        commonCode: 'liquidProductionRate',
        isActive: true,
    },
    liquidProductionRateTheorIncreaseM3: {
        type: 'point',
        color: '#2163FF',
        commonCode: 'liquidProductionRate',
        isActive: true,
    },
    // дебиты нефти
    oilProductionRateFactT: { type: 'line', color: '#9D6939', commonCode: 'oilProductionRate', isActive: true },
    oilProductionRateTheorFallT: { type: 'point', color: '#9D6939', commonCode: 'oilProductionRate', isActive: true },
    oilProductionRateTheorIncreaseT: {
        type: 'point',
        color: '#9D6939',
        commonCode: 'oilProductionRate',
        isActive: true,
    },
    // обводненность
    wateringFact: { type: 'line', color: '#5BE4ED', commonCode: 'watering', isActive: true },
    wateringTheorFall: { type: 'point', color: '#5BE4ED', commonCode: 'watering', isActive: true },
    wateringTheorIncrease: { type: 'point', color: '#5BE4ED', commonCode: 'watering', isActive: true },
};

export const DEFAULT_APE_PANELS_SETTINGS = {
    generalPanel: {
        isFixedColumns: false,
        filter: {
            isActive: false,
            settings: null,
        },
        searchValue: null,
    },
    detailPanel: {
        chartSettings: DEFAULT_CHART_SETTINGS,
    },
};

export const STORE_NAME = 'gtm-efficiency';

export const STORE_KEY = 'gtmEfficiency';
